/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Ganturin Vladimir <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {HttpErrorResponse} from '@angular/common/http';
import {ChangeDetectionStrategy, Component} from '@angular/core';
import {ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {NbButtonModule, NbInputModule, NbWindowRef} from '@nebular/theme';
import {ForgotService} from 'compob2b-auth';
import {ApiResponse, BaseComponent, HTTP_STATUS} from 'compob2b-libs';
import {take} from 'rxjs/operators';

@Component({
    selector: 'app-popup-forgot',
    templateUrl: './forgot.component.html',
    imports: [
        ReactiveFormsModule,
        NbButtonModule,
        NbInputModule,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ForgotPasswordComponent extends BaseComponent {
  constructor(protected readonly windowRef: NbWindowRef,
              readonly forgotService: ForgotService) {
    super();
  }

  close(): void {
    this.windowRef.close();
  }

  forgotForm = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
  });

  onSubmit() {
    if (this.forgotForm.valid) {
      this.loading = true;
      this.forgotService.remind(this.forgotForm.value).pipe(take(1)).subscribe({
        next: (_response: ApiResponse<string>) => {
          this.loading = false;
          this.successToast($localize`:@@PasswordRecoverySuccess:На ваш e-mail выслана инструкция по восстановлению пароля`);
          this.windowRef.close();
        },
        error: (error: HttpErrorResponse) => {
          this.loading = false;
          if (error.status === HTTP_STATUS.NOT_FOUND) {
            this.warningToast($localize`:@@EmailNotFound:Пользователь с таким e-mail не найден`);
          } else {
            this.errorToast($localize`:@@PasswordRecoveryError:Возникла ошибка`);
          }
        },
      });
    }
  }
}
